<script setup lang="ts">
import { default as PMessage } from 'primevue/message'
</script>

<template>
  <div class="col-span-12 grid grid-cols-12 gap-4">
    <p-message class="col-span-10 md:col-start-2" severity="error" :closable="false"
      >Vous n'êtes pas autorisé à vous connecter.
    </p-message>
  </div>
</template>
